import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/fd/inventory/group",
        component: List,
        name: "fd.inventory.group",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/inventory/group/create",
        component: Create,
        name: "fd.inventory.group.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/fd/inventory/group/:id/edit",
        component: Edit,
        name: "fd.inventory.group.edit",
        meta: {
            requiresAuth: true,
        },
    },

    // {path: 'fd/inventory/item', component: StockItem, name: 'inventory.item'},
    // {path: 'fd/inventory/item-removed', component: RemovedStockItem, name: 'inventory.item.removed'},
    // {path: 'fd/inventory/barcode/show', component: Barcode, name: 'inventory.barcode'},
    // {path: 'fd/inventory/item/create', component: StockItemCreate, name: 'inventory.item.create'},
    // {path: 'fd/inventory/item/:id/edit', component: StockItemEdit, name: 'inventory.item.edit'},
];
